import data from "../../JsonFolders/portfolio.json";

// A project's "stack" lists names from the Tools & Technologies carousel,
// so the logos stay in one place. Every tool is named, with its logo beside it when there is one.
const LOGOS = Object.fromEntries(data.images.languages.map((l) => [l.alt, l.src]));

export default function TechStack({ stack, active, className = "" }) {
  if (!stack?.length) return null;

  return (
    <ul className={`tech-stack ${className}`} aria-label="Tech stack">
      {stack.map((name) => (
        <li key={name} className={`tech-stack-item ${name === active ? "is-active" : ""}`}>
          {LOGOS[name] && <img src={LOGOS[name]} alt="" width="16" height="16" loading="lazy" decoding="async" />}
          {name}
        </li>
      ))}
    </ul>
  );
}
